
import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { DocumentIcon, FallbackRewardDocIcon, JpgIcon, PdfIcon, PngIcon, SheetIcon, VerticalDotsIcon } from "../../../utils/icons";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { DownAngleV2 } from "../../SocialFeedsV2/styles";
import CommonListView from "../../common/CommonListView/CommonListView";


const DocCell = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0; // ✅ important
`;

const DocIcon = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 6px;
  ${'' /* background: #eef2ff; */}
  display: flex;
  align-items: center;
  justify-content: center;

  color: #184A61;
  font-family: Lato;
  font-size: 14px;
  font-weight: 400;
`;

const DocName = styled.span`
  color: #184A61;
  font-family: Lato;
  font-size: 18px;
  font-weight: 700;
  margin-right:20px;
  text-align: start;
  ${'' /* white-space: normal;
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    display: -webkit-box; */}

    overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  flex: 1;        // ✅ take remaining space
  min-width: 0;   // ✅ allow shrink

    flex: 1;        // ✅ take remaining space
    min-width: 0;   // ✅ allow shrink
    ${'' /* width:50%; */}

`;

const TextCell = styled.div`
  color: #184A61;
  font-family: Lato;
  font-size: 16px;
  ${'' /* text-align: start; */}
  ${'' /* white-space: normal;
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    display: -webkit-box; */}

    overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  min-width: 0; // ✅ important


`;

const MenuWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

/* ---------------- Headers ---------------- */

const headers = [
  { key: "doc", label: "Doc Name", align: "start" },
  { key: "downloads", label: "Downloads" },
  { key: "uploaded_by", label: "Uploaded By" },
  { key: "last_updated", label: "Last Updated" },
  { key: "menu", label: "" },
];

/* ---------------- Component ---------------- */

const DocumentsListView = ({
  documents = [],
  onEdit,
  onDownload,
  onDelete,
}) => {

  const getFileIcon = (ext = "") => {
    const extension = ext.toLowerCase();

    switch (extension) {
    case "pdf":
      return <PdfIcon/>;
    case "jpeg":
    case "jpg":
      return <JpgIcon/>;
    case "png":
      return <PngIcon/>;
    case 'csv':
    case "xls":
    case "xlsx":
      return <SheetIcon/>;
    case 'doc':
    case "docx":
      return <DocumentIcon/>;
    default:
      return <FallbackRewardDocIcon/>; // fallback
    }
  };

  const renderCell = (key, doc) => {

    if (key === "doc") {
      return (
        <DocCell>
          <DocIcon>{getFileIcon(doc?.extension)}</DocIcon>
          <DocName>{doc?.title}</DocName>
        </DocCell>
      );
    }

    if (key === "downloads") {
      return <TextCell>{doc.downloads}</TextCell>;
    }

    if (key === "uploaded_by") {
      return <TextCell>{doc?.uploaded_by}</TextCell>;
    }

    if (key === "last_updated") {
      return <TextCell>{doc?.last_updated}</TextCell>;
    }

    if (key === "menu") {
      return (
        <MenuWrapper>
          <DownAngleV2 feed padding="0 16px" marginL="-140px">
            <DropdownButton id="docMenu" title={<VerticalDotsIcon />}>
              <Dropdown.Item onClick={() => onEdit(doc)}>
                Edit
              </Dropdown.Item>

              <Dropdown.Item onClick={() => onDownload(doc)}>
                Download
              </Dropdown.Item>

              <Dropdown.Item onClick={() => onDelete(doc)}>
                Delete
              </Dropdown.Item>
            </DropdownButton>
          </DownAngleV2>
        </MenuWrapper>
      );
    }

    return null;
  };

  return (
    <CommonListView
      headers={headers}
      data={documents}
      grid="2fr 1fr 1.5fr 1.5fr 40px"
      renderCell={renderCell}
    />
  );
};

/* ---------------- PropTypes ---------------- */

DocumentsListView.propTypes = {
  documents: PropTypes.array.isRequired,
  onEdit: PropTypes.func,
  onDownload: PropTypes.func,
  onDelete: PropTypes.func,
};

export default DocumentsListView;
